import { useState, useEffect } from 'react';

const SERVER_URL = process.env.REACT_APP_SERVER_URL || '';

export function useGames() {
  const [games, setGames]     = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState(null);

  useEffect(() => {
    fetch(`${SERVER_URL}/api/game/catalog`)
      .then(res => {
        if (!res.ok) throw new Error(`Server error ${res.status}`);
        return res.json();
      })
      .then(data => {
        if (data.success && Array.isArray(data.data?.games)) {
          setGames(data.data.games);
        } else {
          throw new Error(data.message || 'Unexpected response format');
        }
      })
      .catch(err => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  return { games, loading, error };
}

export function useGame(slug) {
  const [game, setGame]       = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState(null);

  useEffect(() => {
    if (!slug) return;
    setLoading(true);
    fetch(`${SERVER_URL}/api/game/catalog/${slug}`)
      .then(res => {
        if (!res.ok) throw new Error(`Server error ${res.status}`);
        return res.json();
      })
      .then(data => {
        const g = data.data?.game ?? data.data ?? data;
        if (!g) throw new Error('Game not found');
        setGame(g);
      })
      .catch(err => setError(err.message))
      .finally(() => setLoading(false));
  }, [slug]);

  return { game, loading, error };
}

function randomId(prefix) {
  return `${prefix}_${Math.random().toString(36).slice(2, 10)}`;
}

export function buildGameUrl(game) {
  const params = new URLSearchParams({
    gameId:    game.slug || game.id,
    sessionId: randomId('demo'),
    playerId:  randomId('player'),
    mode:      'demo',
  });
  if (game.frontend_url) {
    return `${game.frontend_url}?${params.toString()}`;
  }
  return `${SERVER_URL}/?${params.toString()}`;
}

export { SERVER_URL };
